export const DAY_FULL_NAMES = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];
export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];
export const DAY_SHORT_NAMES = [
  'Sun.',
  'Mon.',
  'Tue.',
  'Wed.',
  'Thu.',
  'Fri.',
  'Sat.'
];
